import {
  TemplateState,
  GET_TEMPLATE,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILURE,
  RESET_TEMPLATE,
  TemplateActionTypes,
} from "../types/templateTypes";

const initialState: TemplateState = {
  templateList: [],
  templateData: [],
  templateSuccess: null,
  templateError: null,
  templateLoading: false,
};

export const templateReducer = (
  state = initialState,
  action: TemplateActionTypes
): TemplateState => {
  switch (action.type) {
    case GET_TEMPLATE: {
      return {
        ...state,
        templateSuccess: null,
        templateError: null,
        templateLoading: true,
      };
    }

    case GET_TEMPLATE_SUCCESS: {
      return {
        ...state,
        templateList: action.payload?.data,
        templateSuccess: action.payload?.message,
        templateError: null,
        templateLoading: false,
      };
    }

    case GET_TEMPLATE_FAILURE: {
      return {
        ...state,
        templateError: action.payload,
        templateSuccess: null,
        templateLoading: false,
      };
    }

    case RESET_TEMPLATE: {
      return {
        ...state,
        templateSuccess: null,
        templateError: null,
        templateLoading: false,
      };
    }

    default:
      return state;
  }
};
